var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuelTruckImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 205,
    viewBox: "0 0 444 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.117 204.49C339.07 204.49 436.312 196.745 436.312 187.192C436.312 177.638 339.07 169.893 219.117 169.893C99.1634 169.893 1.922 177.638 1.922 187.192C1.922 196.745 99.1634 204.49 219.117 204.49Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.813 161.197H8.82886V97.7714H124.519V120.283C124.519 142.412 106.932 160.534 84.813 161.197Z",
    fill: "#363C4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M435.613 133.412H432.372V119.337H435.613C436.65 119.337 437.491 120.177 437.491 121.215V131.534C437.491 132.572 436.65 133.412 435.613 133.412Z",
    fill: "#EB4747"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M423.36 101.659H94.1816V142.984H423.36C428.39 142.984 432.467 137.793 432.467 131.389V113.254C432.467 106.85 428.39 101.659 423.36 101.659Z",
    fill: "#363C4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1606 143.301H5.91528V166.498H46.1606V143.301Z",
    fill: "#C9C9C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.311 152.371H45.2494",
    stroke: "#F2F2F2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.311 161.485H45.2494",
    stroke: "#F2F2F2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7225 169.688H0V153.852L7.63331 146.218H15.7225V169.688Z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 152.511V159.741C7.03125 161.005 8.05629 162.03 9.32047 162.03C11.3601 162.03 13.013 160.377 13.013 158.338V153.914C13.013 151.874 11.3594 150.221 9.32047 150.221C8.05629 150.221 7.03125 151.246 7.03125 152.511Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 152.099V160.154C7.03125 161.191 7.8717 162.031 8.90863 162.031H9.53093V150.222H8.90863C7.8717 150.221 7.03125 151.062 7.03125 152.099Z",
    fill: "#EB4747"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0936 165.742C11.0936 166.686 10.328 167.451 9.38401 167.451C8.44008 167.451 7.67444 166.686 7.67444 165.742C7.67444 164.798 8.44008 164.032 9.38401 164.032C10.3286 164.032 11.0936 164.798 11.0936 165.742Z",
    fill: "#363C4F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81311 165.658H4.98823",
    stroke: "#363C4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81311 162.587H4.98823",
    stroke: "#363C4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81311 159.517H4.98823",
    stroke: "#363C4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81311 156.446H4.98823",
    stroke: "#363C4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M333.971 106.924H154C150.686 106.924 148 109.61 148 112.924V147.04C148 150.354 150.686 153.04 154 153.04H333.971C337.285 153.04 339.971 150.354 339.971 147.04V112.924C339.971 109.61 337.285 106.924 333.971 106.924Z",
    fill: "#474E63"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.289 115.524C169.614 114.66 159.862 114.808 153.424 115.14C150.341 115.299 148 117.878 148 120.966V146.75C148 150.064 150.686 152.75 154 152.75H334C337.314 152.75 340 150.064 340 146.75V122.208C340 118.537 336.727 115.682 333.064 115.921C326.953 116.32 318.201 116.459 308.711 115.524C294.489 114.122 279.556 114.94 273.867 115.524C268.652 116.108 254.809 116.926 241.156 115.524C227.502 114.122 213.185 114.94 207.733 115.524C203.704 116.011 192.373 116.692 179.289 115.524Z",
    fill: "url(#paint0_linear_4098_42516)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M174.812 106.924H169.449V153.04H174.812V106.924Z",
    fill: "#363C4F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M175.957 151.967L175.957 150.779L169.522 150.779L169.522 151.967L175.957 151.967Z",
    fill: "#D4D4D4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M175.957 147.214L175.957 146.025L169.522 146.025L169.522 147.214L175.957 147.214Z",
    fill: "#D4D4D4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M175.957 142.46L175.957 141.272L169.522 141.272L169.522 142.46L175.957 142.46Z",
    fill: "#D4D4D4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M175.957 109.185L175.957 107.996L169.522 107.996L169.522 109.185L175.957 109.185Z",
    fill: "#D4D4D4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M175.957 113.939L175.957 112.75L169.522 112.75L169.522 113.939L175.957 113.939Z",
    fill: "#D4D4D4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M175.957 118.692L175.957 117.504L169.522 117.504L169.522 118.692L175.957 118.692Z",
    fill: "#D4D4D4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M175.957 123.446L175.957 122.257L169.522 122.257L169.522 123.446L175.957 123.446Z",
    fill: "#D4D4D4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M175.957 128.199L175.957 127.011L169.522 127.011L169.522 128.199L175.957 128.199Z",
    fill: "#D4D4D4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M175.957 132.953L175.957 131.765L169.522 131.765L169.522 132.953L175.957 132.953Z",
    fill: "#D4D4D4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M175.957 137.707L175.957 136.518L169.522 136.518L169.522 137.707L175.957 137.707Z",
    fill: "#D4D4D4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M319.154 106.54H313.388V152.67H319.154V106.54Z",
    fill: "#363C4F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M444 1.08142H130.053V101.659H444V1.08142Z",
    fill: "#C9C9C9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M439.805 5.53735H134.948V97.8397H439.805V5.53735Z",
    fill: "#F2F2F2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M434.904 97.7353H439.805V5.43298H333.524L434.904 97.7353Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M385.943 97.7353H413.234L311.87 5.43298H284.579L385.943 97.7353Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M133.508 13.6064H440.965",
    stroke: "#C9C9C9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M133.508 22.246H440.965",
    stroke: "#C9C9C9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M133.508 30.8855H440.965",
    stroke: "#C9C9C9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M133.508 39.5244H440.965",
    stroke: "#C9C9C9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M133.508 48.1638H440.965",
    stroke: "#C9C9C9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M133.508 56.8033H440.965",
    stroke: "#C9C9C9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M133.508 65.4429H440.965",
    stroke: "#C9C9C9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M133.508 74.0817H440.965",
    stroke: "#C9C9C9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M133.508 82.7212H440.965",
    stroke: "#C9C9C9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M133.508 91.3606H440.965",
    stroke: "#C9C9C9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M350.123 154.462C350.123 132.201 368.169 114.154 390.431 114.154C412.693 114.154 430.739 132.201 430.739 154.462",
    stroke: "#474E63",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M407.469 118.077C417.587 121.747 425.883 130.132 429.444 140.288",
    stroke: "#363C4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M390.605 188.225C408.372 188.225 422.775 173.822 422.775 156.056C422.775 138.289 408.372 123.886 390.605 123.886C372.839 123.886 358.436 138.289 358.436 156.056C358.436 173.822 372.839 188.225 390.605 188.225Z",
    fill: "#474E63"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M396.061 174.383C406.168 171.375 411.924 160.743 408.917 150.636C405.909 140.528 395.277 134.772 385.169 137.78C375.062 140.787 369.306 151.419 372.313 161.527C375.321 171.635 385.953 177.391 396.061 174.383Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M401.435 157.809C402.408 151.842 398.36 146.215 392.392 145.242C386.425 144.268 380.798 148.316 379.824 154.284C378.851 160.251 382.9 165.877 388.867 166.851C394.835 167.824 400.462 163.776 401.435 157.809Z",
    fill: "#C9C9C9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M390.605 161.402C393.558 161.402 395.951 159.008 395.951 156.056C395.951 153.103 393.558 150.709 390.605 150.709C387.653 150.709 385.259 153.103 385.259 156.056C385.259 159.008 387.653 161.402 390.605 161.402Z",
    fill: "#474E63"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M390.535 142.768C391.122 142.768 391.598 142.292 391.598 141.705C391.598 141.118 391.122 140.642 390.535 140.642C389.949 140.642 389.473 141.118 389.473 141.705C389.473 142.292 389.949 142.768 390.535 142.768Z",
    fill: "#474E63"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M400.703 146.921C401.29 146.921 401.766 146.445 401.766 145.858C401.766 145.271 401.29 144.796 400.703 144.796C400.116 144.796 399.64 145.271 399.64 145.858C399.64 146.445 400.116 146.921 400.703 146.921Z",
    fill: "#474E63"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M404.956 157.048C405.543 157.048 406.018 156.572 406.018 155.985C406.018 155.398 405.543 154.922 404.956 154.922C404.369 154.922 403.893 155.398 403.893 155.985C403.893 156.572 404.369 157.048 404.956 157.048Z",
    fill: "#474E63"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M400.803 167.216C401.39 167.216 401.865 166.74 401.865 166.153C401.865 165.566 401.39 165.09 400.803 165.09C400.216 165.09 399.74 165.566 399.74 166.153C399.74 166.74 400.216 167.216 400.803 167.216Z",
    fill: "#474E63"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M389.613 170.406C389.613 169.819 390.089 169.344 390.675 169.344C391.262 169.344 391.738 169.82 391.738 170.406C391.738 170.994 391.262 171.469 390.675 171.469C390.089 171.469 389.613 170.993 389.613 170.406Z",
    fill: "#474E63"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M379.756 165.501C380.171 165.085 380.844 165.085 381.259 165.501C381.674 165.916 381.674 166.589 381.259 167.004C380.844 167.419 380.171 167.419 379.756 167.004C379.341 166.589 379.341 165.916 379.756 165.501Z",
    fill: "#474E63"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M376.254 157.188C376.841 157.188 377.317 156.713 377.317 156.126C377.317 155.539 376.841 155.063 376.254 155.063C375.667 155.063 375.192 155.539 375.192 156.126C375.192 156.713 375.667 157.188 376.254 157.188Z",
    fill: "#474E63"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M380.409 147.02C380.996 147.02 381.472 146.545 381.472 145.958C381.472 145.371 380.996 144.895 380.409 144.895C379.822 144.895 379.346 145.371 379.346 145.958C379.346 146.545 379.822 147.02 380.409 147.02Z",
    fill: "#474E63"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M399.271 132.238C405.289 134.716 410.404 139.326 413.493 145.055",
    stroke: "#363C4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M371.137 167.168C373.919 171.693 378.06 175.37 382.883 177.597",
    stroke: "#363C4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1442 188.225C112.911 188.225 127.314 173.822 127.314 156.055C127.314 138.289 112.911 123.886 95.1442 123.886C77.3776 123.886 62.9749 138.289 62.9749 156.055C62.9749 173.822 77.3776 188.225 95.1442 188.225Z",
    fill: "#474E63"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M102.339 173.754C112.109 169.785 116.812 158.647 112.843 148.876C108.874 139.106 97.7354 134.403 87.9651 138.373C78.1948 142.342 73.4921 153.48 77.4614 163.25C81.4307 173.021 92.5688 177.723 102.339 173.754Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M105.964 157.82C106.937 151.853 102.889 146.227 96.9212 145.253C90.9536 144.28 85.3269 148.328 84.3535 154.295C83.3801 160.262 87.4287 165.889 93.3963 166.862C99.3639 167.836 104.991 163.788 105.964 157.82Z",
    fill: "#C9C9C9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M95.144 161.402C98.0966 161.402 100.49 159.008 100.49 156.056C100.49 153.103 98.0966 150.709 95.144 150.709C92.1914 150.709 89.7979 153.103 89.7979 156.056C89.7979 159.008 92.1914 161.402 95.144 161.402Z",
    fill: "#474E63"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0735 142.768C95.6605 142.768 96.1363 142.292 96.1363 141.705C96.1363 141.118 95.6605 140.642 95.0735 140.642C94.4866 140.642 94.0107 141.118 94.0107 141.705C94.0107 142.292 94.4866 142.768 95.0735 142.768Z",
    fill: "#474E63"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M105.241 146.921C105.828 146.921 106.304 146.445 106.304 145.858C106.304 145.271 105.828 144.795 105.241 144.795C104.654 144.795 104.178 145.271 104.178 145.858C104.178 146.445 104.654 146.921 105.241 146.921Z",
    fill: "#474E63"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M109.495 157.048C110.082 157.048 110.557 156.572 110.557 155.985C110.557 155.398 110.082 154.922 109.495 154.922C108.908 154.922 108.432 155.398 108.432 155.985C108.432 156.572 108.908 157.048 109.495 157.048Z",
    fill: "#474E63"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M105.341 167.216C105.928 167.216 106.403 166.74 106.403 166.153C106.403 165.566 105.928 165.09 105.341 165.09C104.754 165.09 104.278 165.566 104.278 166.153C104.278 166.74 104.754 167.216 105.341 167.216Z",
    fill: "#474E63"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1514 170.406C94.1514 169.819 94.6275 169.343 95.2142 169.343C95.8008 169.343 96.277 169.82 96.277 170.406C96.277 170.994 95.8008 171.469 95.2142 171.469C94.6275 171.469 94.1514 170.993 94.1514 170.406Z",
    fill: "#474E63"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2944 165.5C84.7097 165.085 85.3824 165.085 85.7977 165.5C86.213 165.916 86.213 166.588 85.7977 167.004C85.3824 167.419 84.7097 167.419 84.2944 167.004C83.8791 166.589 83.8791 165.916 84.2944 165.5Z",
    fill: "#474E63"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7935 157.188C81.3805 157.188 81.8563 156.712 81.8563 156.125C81.8563 155.538 81.3805 155.063 80.7935 155.063C80.2065 155.063 79.7307 155.538 79.7307 156.125C79.7307 156.712 80.2065 157.188 80.7935 157.188Z",
    fill: "#474E63"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9466 147.02C85.5336 147.02 86.0094 146.544 86.0094 145.957C86.0094 145.371 85.5336 144.895 84.9466 144.895C84.3596 144.895 83.8838 145.371 83.8838 145.957C83.8838 146.544 84.3596 147.02 84.9466 147.02Z",
    fill: "#474E63"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M109.083 132.615C115.807 136.255 120.616 143.232 121.625 150.811",
    stroke: "#363C4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2791 163.019C73.9145 168.872 78.1392 173.951 83.5972 176.623",
    stroke: "#363C4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2974 179.568C88.3846 179.568 88.4718 179.568 88.5597 179.568",
    stroke: "#363C4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4014 161.941V151.573C51.4014 128.103 70.4276 109.077 93.8974 109.077H95.7203C119.19 109.077 138.216 128.103 138.216 151.573V161.941",
    stroke: "#474E63",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M108.493 109.794C122.406 114.221 133.872 125.699 138.286 139.617",
    stroke: "#363C4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2815 101.013H124.518V24.7498C124.518 24.7498 119.985 15.4733 106.191 14.742C62.4947 12.4248 44.3411 17.6423 37.9132 20.4629C36.0953 21.2607 34.6094 22.6536 33.7144 24.4254L5.71655 79.831V140.307H47.4659C49.3761 118.081 67.9745 101.013 90.2815 101.013Z",
    fill: "#C4C0D0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9855 25.0574V90.8002H78.0522C56.1599 90.8002 38.4131 108.547 38.4131 130.439H5.71655V140.307H47.4659C48.9461 122.047 63.1555 103.537 86.7595 101.013H124.518V25.0574H79.9855ZM117.638 64.2385H88.5537V31.0238H117.638V64.2385Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6875 91.1743V73.6653H22.894V129.928H37.8013L37.9446 128.599C40.0506 109.122 55.2522 93.6376 74.6875 91.1743Z",
    stroke: "#8F86A6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5054 24.749H123.897",
    stroke: "#8F86A6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0742 25.0078V101.284",
    stroke: "#8F86A6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2275 21.939H114.651",
    stroke: "#8F86A6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6729 69.4666C56.6375 69.4666 65.6014 69.4666 74.566 69.4666",
    stroke: "#8F86A6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8291 69.4666H114.651",
    stroke: "#8F86A6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8291 90.1366H114.651",
    stroke: "#8F86A6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5386 77.9892C66.4348 77.9892 68.3311 77.9892 70.2274 77.9892C70.9021 77.9892 70.9035 76.9404 70.2274 76.9404C68.3311 76.9404 66.4348 76.9404 64.5386 76.9404C63.8638 76.9404 63.8624 77.9892 64.5386 77.9892Z",
    fill: "#363C4F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9759 24.3393L33.4886 23.852C32.732 23.0954 32.732 21.8683 33.4886 21.1118L34.8758 19.7245C35.6323 18.968 36.8595 18.968 37.616 19.7245L38.1034 20.2119L33.9759 24.3393Z",
    fill: "#363C4F"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5549 21.646L56.4502 0.75",
    stroke: "#363C4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1651 28.6934H31.5574L10.3881 70.5867H11.2117C15.6343 70.5867 19.6428 67.9849 21.444 63.9463L37.1651 28.6934Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0014 64.8539H74.6877V28.8927H41.0618L25.0414 64.9896C23.8996 67.562 25.7826 70.4581 28.5969 70.4581H43.3972C43.3965 67.3634 45.906 64.8539 49.0014 64.8539Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3896 52.0793L64.0359 36.433",
    stroke: "#BDDEFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0061 52.6812L62.1136 45.5737",
    stroke: "#BDDEFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8359 42.902L22.483 70.6356H35.8359V42.902Z",
    stroke: "#8F86A6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8009 72.2508H22.8158C21.7055 72.2508 20.8063 71.3509 20.8063 70.2406V68.8114C20.8063 67.701 21.7062 66.8011 22.8158 66.8011H24.8009C25.9112 66.8011 26.8104 67.701 26.8104 68.8114V70.2406C26.8104 71.3509 25.9105 72.2508 24.8009 72.2508Z",
    fill: "#363C4F"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4878 63.4519H37.3783C35.6673 63.4519 34.2808 62.0646 34.2808 60.3537V37.323C34.2808 35.612 35.668 34.2255 37.3783 34.2255H39.4878V63.4519Z",
    fill: "#363C4F"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3307 80.5352H5.71655V119.687H10.3307V80.5352Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4398 119.717H13.784C13.2749 119.717 12.8617 119.304 12.8617 118.795V81.4462C12.8617 80.9372 13.2742 80.5239 13.784 80.5239H14.4398C14.9488 80.5239 15.3621 80.9365 15.3621 81.4462V118.795C15.3621 119.304 14.9488 119.717 14.4398 119.717Z",
    fill: "#363C4F"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00781 123.293V130.524C8.00781 131.788 9.03286 132.813 10.297 132.813C12.3366 132.813 13.9896 131.16 13.9896 129.121V124.697C13.9896 122.657 12.3366 121.004 10.297 121.004C9.03286 121.004 8.00781 122.029 8.00781 123.293Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00781 122.881V130.936C8.00781 131.973 8.84827 132.813 9.8852 132.813H10.5075V121.004H9.8852C8.84827 121.004 8.00781 121.845 8.00781 122.881Z",
    fill: "#EB4747"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71655 82.6154H10.3307",
    stroke: "#BDDEFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71655 86.9303H10.3307",
    stroke: "#BDDEFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71655 91.2451H10.3307",
    stroke: "#BDDEFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71655 95.5598H10.3307",
    stroke: "#BDDEFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71655 99.8748H10.3307",
    stroke: "#BDDEFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71655 104.19H10.3307",
    stroke: "#BDDEFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71655 108.504H10.3307",
    stroke: "#BDDEFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71655 112.82H10.3307",
    stroke: "#BDDEFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71655 117.135H10.3307",
    stroke: "#BDDEFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4098_42516",
    x1: 340.214,
    y1: 114.719,
    x2: 340.214,
    y2: 152.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53DF1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#299900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelTruckImg);
export default __webpack_public_path__ + "static/media/fuel_truck_img.1feadd31994a98c6329a8767920d553b.svg";
export { ForwardRef as ReactComponent };